import { REACT_APP_CLOUDINARY_CLOUD_NAME } from 'env'

export const uploadImageToCloudinary = async (imageUrl: string) => {
  const formData = new FormData()
  let payload

  try {
    formData.append('file', imageUrl)
    formData.append('upload_preset', 'workspace_portal_uploads')

    const response = await fetch(`https://api.cloudinary.com/v1_1/${REACT_APP_CLOUDINARY_CLOUD_NAME}/image/upload`, {
      method: 'POST',
      body: formData,
    })

    const parsedResponse = await response.json()
    payload = parsedResponse
  } catch (error) {
    return null
  }

  return payload
}
